import { ImmerReducer, createActionCreators, createReducerFunction } from 'immer-reducer';
import { ISidebarState } from '../../interfaces/states/ISidebarState';
import { ISidebarButton } from '../../interfaces/dtos/ISidebarButton';

const initialState: ISidebarState = {
  isCollapsed: false,
  canBeCollapsed: true,
  buttons: [],
  currentPage: 1,
};

class SidebarReducer extends ImmerReducer<ISidebarState> {
  public addButton(button: ISidebarButton): void {
    this.draftState.buttons.push(button);
  }

  public setButtons(buttons: ISidebarButton[]): void {
    this.draftState.buttons = buttons;
  }

  public clearButtons(): void {
    this.draftState.buttons = [];
  }

  public toggleSidebar(): void {
    if (this.state.canBeCollapsed) {
      this.draftState.isCollapsed = !this.state.isCollapsed;
    }
  }

  public setCanBeCollapsed(canBeCollapsed: boolean): void {
    this.draftState.canBeCollapsed = canBeCollapsed;
    if (this.state.isCollapsed || !canBeCollapsed) {
      this.draftState.isCollapsed = false;
    }
  }

  public setCurrentPage(newPage: number): void {
    if (newPage > 0) {
      this.draftState.currentPage = newPage;
    } else {
      this.draftState.currentPage = 1;
    }
  }

  public resetSidebar(): void {
    this.draftState = initialState;
  }

  public showSideBar(): void {
    this.draftState.isCollapsed = false;
  }
}

export const SidebarActions = createActionCreators(SidebarReducer);
export const SidebarReducerFunction = createReducerFunction(SidebarReducer, initialState);
